import React from 'react';
import { Button } from '@geberit/gdds';

// components
import { Translation } from '../../Translation/Translation';

import styles from './noresults.module.scss';

interface NoResultsProps {
  textKey: string;
  buttonHandler: (() => void) | ((filterResetValue: any) => void);
  buttonKey?: string;
}

function NoResults({ textKey, buttonKey, buttonHandler }: Readonly<NoResultsProps>) {
  return (
    <div className={styles.noResultsWrapper}>
      <p>
        <Translation id={textKey} />
      </p>
      {buttonKey && (
        <Button stylingType="primary" onClick={buttonHandler}>
          <Translation id={buttonKey} />
        </Button>
      )}
    </div>
  );
}

export default NoResults;
